<template>
    <div class="page-container">
        <!-- 导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="goBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">用户隐私服务政策</span>
            <div class="nav-placeholder"></div>
        </div>
        <!-- 导航栏占位符，防止内容被遮挡 -->
        <div class="nav-placeholder-element"></div>

        <!-- 协议内容 -->
        <div class="privacy-content">
            <div v-if="loading" class="loading">
                <span>加载中...</span>
            </div>
            <div v-else-if="content" v-html="content" class="policy-html"></div>
            <div v-else class="empty">
                <span>暂无隐私政策内容</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Privacy',
    data() {
        return {
            loading: true,
            content: ''
        }
    },
    mounted() {
        this.fetchPrivacyPolicy()
    },
    methods: {
        goBack() {
            this.$router.back()
        },

        fetchPrivacyPolicy() {
            try {
                const enterpriseId = localStorage.getItem('caregiver_selected_enterprise_id') || ''
                
                let url = '/api-enterprise/agreement/get2'
                this.$api.post(url, { enterpriseId: enterpriseId }, response => {
                    this.loading = false
                    if (response.data.result === 'success' && response.data.data && response.data.data.privacyPolicyHtml) {
                        this.content = response.data.data.privacyPolicyHtml
                    }
                }, error => {
                    this.loading = false
                    console.error('fetchPrivacyPolicy fail:', error)
                })
            } catch (err) {
                this.loading = false
                console.error('fetchPrivacyPolicy fail:', err)
            }
        }
    }
}
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
    }

    /* 导航栏 */
    .nav-bar {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    /* 导航栏占位符 */
    .nav-placeholder-element {
        height: 44px;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* 内容区域 */
    .privacy-content {
        padding: 15px;
    }

    .loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;
        color: #999;
        font-size: 14px;
    }

    .policy-html {
        background-color: #fff;
        border-radius: 8px;
        padding: 15px;
        min-height: 500px;
        line-height: 1.8;
        font-size: 14px;
        color: #333;
    }

    .policy-html h1 {
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        margin-bottom: 15px;
        color: #333;
    }

    .policy-html h2 {
        font-size: 14px;
        font-weight: 600;
        margin-top: 12px;
        margin-bottom: 8px;
        color: #333;
    }

    .policy-html p {
        margin-bottom: 8px;
        text-indent: 2em;
    }

    .policy-html ul,
    .policy-html ol {
        padding-left: 20px;
        margin-bottom: 8px;
    }

    .policy-html li {
        margin-bottom: 4px;
    }

    .empty {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        color: #999;
        font-size: 14px;
    }
</style>